import KendoDateAndOrTimePickerViewModelBase from '@/Components/KendoDateTimePicker/ViewModels/KendoDateAndOrTimePickerViewModelBase';
import ComponentManager from '@/Management/ComponentManager';
import * as DateHelper from '@/Utility/DateHelper'
import LinkViewModelT from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModelT from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModelT from '@/ViewModels/Controls/ImageViewModel';
import ResourceManager from '@/Management/ResourceManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class KendoTimePickerViewModel extends KendoDateAndOrTimePickerViewModelBase {

    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelT>('LinkViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModelT>('ImageViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelT>('LabelViewModel');

    /**
     * Die minimal auswählbare Zeit im TimePicker
     */
    public min: KnockoutObservable<string>;

    /**
     * Die maximal auswählbare Zeit im TimePicker
     */
    public max: KnockoutObservable<string>;

    /**
     * Das ViewModel für den Link zum Auwählen einer Uhrzeit
     */
    public link: LinkViewModelT;
    
    public constructor(params: any) {
        super(params);

        this.min = this.observableOrDefault(params.min, '00:00');
        this.max = this.observableOrDefault(params.max, '00:00');
        this.link = this.createLinkViewModel();
    }

    /**
     * @override
     * @inheritdoc 
     * @param date
     */
    protected parseToDotNetString(date: Date): string {
        return DateHelper.toDotNetDateTimeString(date);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public createPlaceHolder(): KnockoutComputed<string> {
        return this.defineComputed(() => {
            const language = ResourceManager.getInstance().getLanguage();
            return language.timePattern;
        });
    }

    private createLinkViewModel(): LinkViewModelT {
        return new this.LinkViewModel({
            parentLocator: this.locator,
            locator: 'button.open-timepicker',
            image: new this.ImageViewModel({
                source: GlobalConfiguration.inlineImages.TIMEPICKER,
                alternativeText: new this.LabelViewModel({
                    ergName: 'FACTORY_TIMEPICKER'
                })
            }),
            isFocusable: this.isFocusable,
            isVisible: this.isEnabled,
            isToolBarLink: true
        });
    }
}

ComponentManager.setViewModel('KendoTimePickerViewModel', KendoTimePickerViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');